import angular from 'angular'

angular
  .module('ggs.gallery-empty')
  .factory('GalleryEmptyStyleHandlers', GalleryEmptyStyleHandlersProvider)

function GalleryEmptyStyleHandlersProvider(rootQs, GSNApplyStyleTmpl) {

  const OWNER_TAG = __filename

  return function GalleryEmptyStyleHandlers() {

    // applyColor

    const COLOR_PLH = ':color:'
    const COLOR_TMPL = `
      ${rootQs} .ggs-gallery-empty__text {
        color: ${COLOR_PLH};
      }`

    const applyColor = GSNApplyStyleTmpl({
      propKeys: 'empty_placeholder_text_color',
      ownerTag: OWNER_TAG,
      styleTmpl: COLOR_TMPL,
      stylePlh: COLOR_PLH
    })

    // return

    return [
      applyColor
    ]
  }
}
